const e = {
  add: "Add",
  cancel: "Cancel",
  clear: "Clear",
  confirm: "Confirm",
  delete: "Delete",
  redo: "Redo",
  save: "Save",
  saveAs: "Save as",
  undo: "Undo"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, t = {
  cancel: "Cancel",
  confirm: "Confirm",
  datePlaceholder: "Select Date",
  datetimePlaceholder: "Select Date and Time",
  endDatePlaceholder: "End Date",
  endDatetimePlaceholder: "End Date and Time",
  endMonthPlaceholder: "End Month",
  monthPlaceholder: "Select Month",
  now: "Now",
  quarterPlaceholder: "Select Quarter",
  selectDate: "Select Date",
  selectTime: "Select Time",
  startDatePlaceholder: "Start Date",
  startDatetimePlaceholder: "Start Date and Time",
  startMonthPlaceholder: "Start Month",
  today: "Today",
  weekPlaceholder: "Select Week",
  yearPlaceholder: "Select Year",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, o = {
  placeholder: "Please Select"
}, l = {
  clear: "Clear",
  negativeText: "Cancel",
  now: "Now",
  placeholder: "Select Time",
  positiveText: "OK"
}, r = {
  placeholder: "Please Input"
}, n = {
  placeholder: "Please Input"
}, c = {
  placeholder: "Start typing..."
}, s = {
  allRows: "All rows",
  default: "Default",
  deleteLayoutDescription: "Are you sure you want to delete this layout?",
  discardChanges: "Discard changes",
  discardLayoutChanges: "Discard layout changes",
  enterLayoutName: "Enter layout name",
  enterRowNumber: "Enter number of rows",
  fieldsSelected: "fields selected",
  freezeColumnDescription: "Freeze the column to the left",
  freezeUptoColumn: "Freeze upto column",
  frozen: "Frozen",
  layoutName: "Layout Name",
  manageColumns: "Manage Columns",
  none: "None",
  reorderRows: "Reorder Rows",
  rowsSelected: "rows selected",
  saveLayoutAs: "Save layout as",
  saveLayoutNew: "Save new layout",
  search: "Search",
  searchColumnsPlaceholder: "Search columns",
  searchFieldsPlaceholder: "Search fields",
  selectAll: "Select all",
  setTableHeight: "Set table height",
  unfreeze: "Unfreeze",
  unsavedChanges: "You have unsaved changes",
  unsavedChangesDescription: "There might be one or more unsaved changes. Do you want to save them?"
}, d = {
  at: "at",
  colorAlreadyUsed: "Choose a different shade or use existing",
  colorNamePlaceholder: "Enter Name",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Please choose a different color name",
  noColorsAdded: "You do not have any colors in this section."
}, i = {
  searchPlaceholder: "Search"
}, h = {
  invalidPastedData: "Invalid pasted data"
}, u = {
  of: "of",
  page: "Page",
  rowsPerPage: "Rows per page"
}, p = {
  failedToUpload: "Failed to upload",
  retry: "Retry",
  clickToUpload: "Click to upload",
  orDragAndDrop: "or drag and drop",
  supportedFileTypes: "Supported file types:"
}, m = {
  global: e,
  Progress: a,
  DatePicker: t,
  Select: o,
  TimePicker: l,
  Input: r,
  InputNumber: n,
  InputTag: c,
  HLDataTable: s,
  ColorPicker: d,
  InputPhone: i,
  InputOtp: h,
  Pagination: u,
  Upload: p
};
export {
  d as ColorPicker,
  t as DatePicker,
  s as HLDataTable,
  r as Input,
  n as InputNumber,
  h as InputOtp,
  i as InputPhone,
  c as InputTag,
  u as Pagination,
  a as Progress,
  o as Select,
  l as TimePicker,
  p as Upload,
  m as default,
  e as global
};
